import { createAction, props } from '@ngrx/store';
import { FieldMap } from 'angular2-query-builder/dist/components';

export const getOrderFieldMap = createAction('[Field Map Request] Get Order Field Map');
export const saveOrderFieldMap = createAction('[Field Map State] Save Order Field Map', props<{ orderFieldMap: FieldMap }>());
export const markOrderFieldMapLoaded = createAction('[Field Map State] Mark Order Field Map Loaded');
